import React from "react";
import { useTranslation } from "react-i18next";

interface TableProps {
  data: Record<string, any>[] | undefined; // Array of objects with unknown keys
}

export default function DynamicTable({ data }: TableProps) {
  const { t } = useTranslation("reports");

  if (!data || data.length === 0) return <p className="text-gray-500">{t("No data available")}</p>;

  // Extract column headers dynamically
  const columns = Object.keys(data[0]);

  return (
    <div className="overflow-x-auto">
      <table className="w-full border border-gray-300 rounded-lg shadow-sm">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            {columns.map((col) => (
              <th key={col} className="p-2 border-b border-gray-300 text-left">
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="border-b border-gray-200 odd:bg-white even:bg-gray-50 hover:bg-gray-100 transition"
            >
              {columns.map((col) => (
                <td key={col} className="p-2 text-gray-800">
                  {row[col] !== null && row[col] !== undefined ? row[col] : "—"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
